import { combineReducers } from 'redux';
import amazonWebServicesReducer from './amazonWebServicesReducer';
import checkmateAuthorizationReducer from './checkmateAutorizationReducer';
import transactionReducer from './transactionReducer';
import dateRangeReducer from './dateRangeReducer'
import ordersPageReducer from './ordersPageReducer';
import paymentsPageReducer from './paymentsPageReducer';
import storePageReducer from './storePageReducer';
import merchantReducer from './merchantReducers';
import loginServiceReducer from './loginServiceReducer';
import accountServiceReducer from './accountServiceReducer';
import merchantsInfoReducer from './adminFlow/merchantInfoReducer';
import createAccountReducer from './adminFlow/createAccountReducer';
import getStartedReducer from './getStartedReducer';
import onboardingmerchantsInfoReducer from './adminFlow/onboardingmerchantInfoReducer';
import businessInfoReducer from '../reducers/adminFlow/businessInfoReducer';
import approvebusinessInfoReducer from '../reducers/adminFlow/approvebusinessInfoReducer';
import rejectbusinessInfoReducer from '../reducers/adminFlow/rejectbusinessInfoReducer';

const combinedReducer = combineReducers({
  checkmateAuthorizationReducer,
  transactionReducer,
  ordersPageReducer,
  paymentsPageReducer,
  amazonWebServicesReducer,
  checkmateAuthorizationReducer,
  dateRangeReducer,
  storePageReducer,
  merchantReducer,
  loginServiceReducer,
  accountServiceReducer,
  merchantsInfoReducer,
  onboardingmerchantsInfoReducer,
  createAccountReducer,
  getStartedReducer,
  businessInfoReducer,
  approvebusinessInfoReducer,
  rejectbusinessInfoReducer
});

const rootReducer = (state, action) => {
  // console.log('ACTION ',action)
  if (action.type === 'INITIALIZE_MERCHANT_STATE') {
    state = undefined
  }
  return combinedReducer(state, action)
}


export default rootReducer;